import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { IAccClaimDeclaration } from '@principle-theorem/principle-core/interfaces';
import { ISODateType, toISODate } from '@principle-theorem/shared';
import { hasRequiredError } from './form-group-helpers';
import * as moment from 'moment-timezone';

export class AccSummaryDeclarationFormGroup extends TypedFormGroup<IAccClaimDeclaration> {
  constructor() {
    super({
      providerDeclaration: new TypedFormControl<ISODateType>(
        toISODate(moment()),
        Validators.required
      ),
    });
  }

  get providerDeclarationRequiredError(): boolean {
    return hasRequiredError(this.controls.providerDeclaration);
  }
}
